<template>
  <v-overlay :value="show" :opacity="0.02" style="z-index: 7 !important">
    <div class="vl-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" height="128" width="128" :fill="color">
        <rect x="0" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite" />
        </rect>
        <rect x="10" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
        </rect>
        <rect x="20" y="13" width="4" height="5">
          <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
        </rect>
      </svg>
    </div>
  </v-overlay>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: '#E5502C'
      }
    }
  };
</script>
